// Futuristic Blue & White Theme Configuration
// Modern, sleek design with shades of blue and white

export const themeConfig = {
  token: {
    // Primary colors - Futuristic Blue shades
    colorPrimary: '#0066ff',
    colorSuccess: '#00d9ff',
    colorWarning: '#ffb800',
    colorError: '#ff3366',
    colorInfo: '#0066ff',
    
    // Background colors - Clean White with subtle blue tints
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#f8faff',
    colorBgLayout: '#f0f4ff',
    
    // Text colors - Deep blue and gray
    colorText: '#0a1629',
    colorTextSecondary: '#6b7a99',
    colorTextTertiary: '#9aa4bf',
    colorTextQuaternary: '#c4cbd9',
    
    // Border colors - Light blue-gray
    colorBorder: '#e1e8f0',
    colorBorderSecondary: '#f0f4ff',
    
    // Link colors - Bright blue
    colorLink: '#0066ff',
    colorLinkHover: '#0052cc',
    colorLinkActive: '#003d99',
    
    // Font settings - Modern typography
    fontSize: 14,
    fontSizeLG: 16,
    fontSizeSM: 12,
    fontSizeXL: 20,
    fontSizeHeading1: 42,
    fontSizeHeading2: 32,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 16,
    
    // Border radius - Smooth, modern curves
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,
    
    // Spacing - Generous padding
    padding: 16,
    paddingLG: 24,
    paddingSM: 12,
    paddingXS: 8,
    paddingXXS: 4,
    margin: 16,
    marginLG: 24,
    marginSM: 12,
    marginXS: 8,
    marginXXS: 4,
    
    // Box shadow - Subtle depth with blue tint
    boxShadow: '0 4px 16px rgba(0, 102, 255, 0.08)',
    boxShadowSecondary: '0 2px 8px rgba(0, 102, 255, 0.06)',
    boxShadowTertiary: '0 1px 4px rgba(0, 102, 255, 0.04)',
    
    // Control heights
    controlHeight: 36,
    controlHeightLG: 44,
    controlHeightSM: 28,
    
    // Line heights
    lineHeight: 1.5715,
    lineHeightLG: 1.5,
    lineHeightSM: 1.66,
    
    // Wireframe - Disable for cleaner look
    wireframe: false,
  },
  components: {
    // Button - Futuristic with gradient effects
    Button: {
      primaryColor: '#ffffff',
      borderRadius: 8,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 28,
      fontWeight: 600,
      paddingContentHorizontal: 20,
      paddingContentHorizontalLG: 28,
      paddingContentHorizontalSM: 16,
      boxShadow: '0 2px 8px rgba(0, 102, 255, 0.2)',
    },
    // Input - Clean with blue focus
    Input: {
      borderRadius: 8,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 28,
      colorBgContainer: '#ffffff',
      activeBorderColor: '#0066ff',
      hoverBorderColor: '#3385ff',
      paddingInline: 14,
      paddingBlock: 6,
    },
    // Card - Elevated with subtle shadow
    Card: {
      borderRadius: 12,
      paddingLG: 24,
      colorBgContainer: '#ffffff',
      boxShadow: '0 4px 16px rgba(0, 102, 255, 0.08)',
      headerBg: 'transparent',
      actionsBg: '#f8faff',
      colorBorderSecondary: '#e1e8f0',
    },
    // Table - Clean and modern
    Table: {
      borderRadius: 12,
      headerBg: '#f8faff',
      headerColor: '#0a1629',
      rowHoverBg: '#f0f4ff',
      cellPaddingBlock: 14,
      cellPaddingInline: 16,
      headerBorderRadius: 12,
    },
    // Layout - Clean structure
    Layout: {
      bodyBg: '#f0f4ff',
      headerBg: '#ffffff',
      headerPadding: '0 32px',
      headerHeight: 72,
      siderBg: '#001529',
      triggerBg: '#002140',
      triggerColor: '#ffffff',
    },
    // Form - Spacious
    Form: {
      labelColor: '#0a1629',
      labelFontSize: 14,
      itemMarginBottom: 24,
      verticalLabelPadding: '0 0 8px',
      labelHeight: 36,
    },
    // Select - Modern dropdown
    Select: {
      borderRadius: 8,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 28,
      colorBgContainer: '#ffffff',
      optionSelectedBg: '#e6f2ff',
      optionActiveBg: '#f0f4ff',
    },
    // Modal - Elevated dialog
    Modal: {
      borderRadius: 16,
      paddingContentHorizontal: 32,
      paddingContentVertical: 24,
      headerBg: '#ffffff',
      titleFontSize: 20,
      titleLineHeight: 1.4,
      boxShadow: '0 8px 32px rgba(0, 102, 255, 0.12)',
    },
    // Message - Clean notifications
    Message: {
      contentPadding: '12px 20px',
      borderRadius: 8,
      fontSize: 14,
      zIndexPopup: 1010,
    },
    // Notification
    Notification: {
      borderRadius: 12,
      paddingContentHorizontal: 24,
      paddingContentVertical: 20,
      fontSize: 14,
      zIndexPopup: 1010,
      boxShadow: '0 4px 16px rgba(0, 102, 255, 0.12)',
    },
    // Alert
    Alert: {
      borderRadius: 8,
      paddingContent: 14,
      fontSize: 14,
    },
    // Typography
    Typography: {
      titleMarginBottom: '0.5em',
      titleMarginTop: '1.2em',
    },
    // Space
    Space: {
      sizeSmall: 8,
      sizeMiddle: 16,
      sizeLarge: 24,
    },
    // Tag - Modern badges
    Tag: {
      borderRadius: 6,
      fontSizeSM: 12,
      lineHeightSM: 1.5,
    },
    // Tabs - Clean navigation
    Tabs: {
      itemColor: '#6b7a99',
      itemSelectedColor: '#0066ff',
      itemHoverColor: '#3385ff',
      itemActiveColor: '#0066ff',
      inkBarColor: '#0066ff',
    },
  },
};

